import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from "../../pages/home/SideBar/Sidebar";
import Header from "../../pages/home/Header";
import PostBox from "../../pages/home/PostBox";
import { useLayout } from './useLayout';
import './layout.css'; // Contains --post-width variable that controls post width
import TrendingPanel from '../trending/TrendingPanel';
import { FloatingChatManager } from '../../features/chat';
import { FeedRefreshProvider } from '../../features/feed';


function HomeLayout() {
  const { isMobile, toggleMobileMenu } = useLayout();
  const isSidebarOpen = useSelector(state => state.ui.isSidebarOpen);
  const location = useLocation();
  const isSolutionBuilderPage = location.pathname.includes('/solutions/');

  return (
    <FeedRefreshProvider>
      <div className={`layout home-page${isSolutionBuilderPage ? ' solutions-page' : ''}`}>
        {/* Header */}
        <div className="layout-header">
          <Header onMenuClick={toggleMobileMenu} isMobile={isMobile} />
        </div>

        {/* Sidebar */}
        <div className={`layout-sidebar ${isMobile ? 'mobile' : ''} ${isSidebarOpen ? 'open' : ''}`}>
          <Sidebar />
        </div>
        {isMobile && isSidebarOpen && (
          <div className="mobile-menu-overlay" onClick={toggleMobileMenu}>
            <div className="mobile-menu">
              <Sidebar />
            </div>
          </div>
        )}

        {/* Main content */}
        <div className={`layout-content${isSolutionBuilderPage ? ' solution-builder-content' : ''}`}>
          {!isSolutionBuilderPage && (
            <>
              {/* Fixed PostBox */}
              <div className="postbox-wrapper">
                <PostBox />
              </div>

              {/* Scrollable Feed - Post width is controlled by --post-width in layout.css */}
              <div className="feed-wrapper">
                <Outlet context={{ isMobile, isHomePage: true }} />
              </div>
            </>
          )}

          {/* Solution Builder content - rendered without the default layout */}
          {isSolutionBuilderPage && (
            <Outlet context={{ isMobile, isHomePage: false }} />
          )}
        </div>

        {/* Right panel */}
        <div className="right-panel">
          {!isSolutionBuilderPage && (
            <div className="right-panel-content">
              <TrendingPanel />
              <FloatingChatManager />
            </div>
          )}
        </div>
      </div>
    </FeedRefreshProvider>
  );
}

export default HomeLayout;